define([
    "./sortingModule",
    "./sortingListModal",
    "./nlgSortingList"
], function () {
});